import { Injectable } from '@angular/core';
import { IModalOptions } from '../common/modals/modal-options.interface';
import { Observable, of } from 'rxjs';
import { RiskHelpComponent } from '../admin-lists/components/risk-help/risk-help.component';
import { IRiskMatrixEntry } from '../message-models/risk-matrix-entry.interface';
import { IRiskInfo } from '../message-models/risk-info.interface';
import { IJobLevelInfo } from '../message-models/job-level.interface';
import { OperativeInfo } from '../domain-model/operative-info.class';
import { CancelOnlyModalOptions } from '../common/modals/cancel-only-modal-options.class';
import { EcaDynamicModalService } from "../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../shared/models/eca-dialog-ref.interface';

@Injectable({
  providedIn: 'root'
})

export class RiskHelpModalService {
  riskHelpModalRef: IEcaDialogRef;

  constructor(private modalService: EcaDynamicModalService) {
  }

  openRiskHelpModal(
    heading: string,
    riskMatrixEntries: IRiskMatrixEntry[],
    allRisks: IRiskInfo[],
    allJobLevels: IJobLevelInfo[],
    operatives: OperativeInfo[] = [],
    options?: IModalOptions,
    asOfDate?: string,
    companyName?: string,
    isQsRole?: boolean
  ): Observable<IEcaDialogRef> {
    if (options === undefined || options === null) {
      options = new CancelOnlyModalOptions();
      options.modalClasses += ' modal-eca-success';
    }

    let config = {
      styleClass: 'modal-xl ' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      data: {
        heading,
        riskMatrixEntries,
        allRisks,
        allJobLevels,
        operatives,
        asOfDate,
        companyName,
        isQsRole
      }
    } as DynamicDialogConfig;

    this.riskHelpModalRef = this.modalService.openDialog(RiskHelpComponent,config);
    return of(this.riskHelpModalRef);
  }
}
